<template>
  <div class="links">
    <div class="table-responsive">

      <div class="table-flex-responsive">
        <div class="row header">
          <div class="col-1"> №</div>
          <div class="col-3"> Текст</div>
          <div class="col">Дата</div>
          <div class="col">Планируемая дата размещения</div>
          <div class="col"></div>
        </div>
        <template v-for="(object, index) in objects">
          <div class="row line">

            <div class="col-1 number">
              <div class="sub-head">№</div>
              {{ index + 1 }}
            </div>
            <div class="col sub-head">Текст</div>
            <div :class="'col-3'+(object.text_error?' form-group--error':'')">
              <template v-if="object.edit">
                <div>
                  <label class="d-none">Текст к размещению</label>
                  <textarea class="form-control" name="" cols="50" rows="15"
                            v-on:keyup="object.text_error = false"
                            v-model="object.text"></textarea>
                </div>
                <div class="error" v-if="object.text_error">{{ object.text_error }}</div>
              </template>
              <template v-else>
                {{ !object.text_trun ? object.text.slice(0, 500) : object.text }}
                <button v-if="object.text.length > 500" class="btn btn-sm text-primary"
                        @click="object.text_trun = !object.text_trun">
                  <i :class="`bi bi-chevron-${object.text_trun?'up':'down'}`"></i></button>
              </template>
            </div>
            <div class="col sub-head">Дата</div>
            <div class="col">{{ object.date }}</div>
            <div class="col sub-head">Планируемая дата размещения</div>
            <div class="col">{{ object.date_place }}</div>
            <div class="col sub-head"></div>
            <div class="col">
              <template v-if="!object.edit">
                <a href="" v-on:click.prevent="object.edit = true;"
                   class="no-wrap"><i class="bi bi-pencil"></i>
                  <small>редактировать</small>
                </a>

              </template>
              <template v-else>
                <a href="" class="text-success ms-sm-2 no-wrap" v-on:click.prevent="saveNote(object)"><i
                    class="bi bi-check-circle"></i>
                  <small>Сохранить</small>
                </a> <br>
                <a href="" class="text-danger ms-sm-2 no-wrap" v-on:click.prevent="endEdit(object)"><i
                    class="bi bi-x-circle"></i>
                  <small>Отмена</small>
                </a>
              </template>
            </div>

          </div>
        </template>
        <div v-if="!objects.length" class="row">
          <div class="col-12 text-center">
            Не добавлено ни одной записи
          </div>
        </div>
        <div>
          <div>
            <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import {DictionaryApi} from "@/api/dictionary";

export default {
  name: "WikiRequests",
  props: ['objects', 'wiki_id'],
  components: {},
  data() {
    return {
      empty: {text: '', edit: true},
      name: "wikipedia/request"
    }
  },
  methods: {
    addNote: function () {
      this.objects.push(JSON.parse(JSON.stringify(this.empty)));
    },
    endEdit(object) {
      let $this = this;
      if (object.id) {
        DictionaryApi.get(this.name, object.id).then(response => {
          $this.objects.splice($this.objects.indexOf(object), 1, response);
        });
      } else this.objects.splice(this.objects.indexOf(object), 1);
      if (this.edit_object) this.edit_object = null;
    },
    saveNote: function (object) {
      // let errors = this.validateData(object);
      if (!object.text) object.text_error = 'Обязательное поле';
      else {
        let $this = this;
        object.wiki = this.wiki_id
        DictionaryApi.save(this.name, object, object.id).then(response => {
          $this.objects.splice($this.objects.indexOf(object), 1, response);
          if ($this.edit_object) $this.edit_object = null;
          if (alert) $this.$notify({
            group: 'alert',
            type: 'success ',
            text: 'Запись сохранена'
          });
        });
      }

    },

  }
}
</script>
